export default "__VITE_ASSET__K1y9nN7O__"